import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';
/**
 * The Progress Components for Question Options.
 */
export function Progress(props) {
  return (
    <label className={`${style.progress} ${props.className}`}>
      {props.label}
    </label>
  );
}

Progress.propTypes = {
  /**
   * className to be set for Progress element
   */
  className: PropTypes.string,
  /**
   * Text to be displayed
   */
  label: PropTypes.string.isRequired,
};

Progress.defaultProps = {
  className: '',
  label: '',
};
